import { render, staticRenderFns } from "./StockRptDetailList.vue?vue&type=template&id=229465a7&scoped=true&"
import script from "./StockRptDetailList.vue?vue&type=script&lang=js&"
export * from "./StockRptDetailList.vue?vue&type=script&lang=js&"
import style0 from "./StockRptDetailList.vue?vue&type=style&index=0&id=229465a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229465a7",
  null
  
)

export default component.exports